import { render } from "./Smartphone1.vue?vue&type=template&id=1bf6db92&scoped=true"
import script from "./Smartphone1.vue?vue&type=script&lang=js"
export * from "./Smartphone1.vue?vue&type=script&lang=js"

import "./Smartphone1.vue?vue&type=style&index=0&id=1bf6db92&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1bf6db92"

export default script